import { useQuery } from '@tanstack/react-query';
import { useAPI } from 'data/api';

export function useCheckClaimedDomainQuery(domain: string | null, enabled: boolean = true) {
  const getAPI = useAPI();

  return useQuery({
    queryKey: ['claimedDomain', domain],
    queryFn: async () => {
      if (!domain) {
        return null;
      }

      const api = await getAPI();
      try {
        const response = await api.orgApi.checkClaimedDomain({ domain });
        return response;
      } catch (error: any) {
        // Check for the specific "domain not claimed" error response
        // This prevents false negatives if the API endpoint changes or returns 404s for other reasons
        const isDomainNotClaimedError = error?.response?.status === 404 && 
          error?.response?.data?.detail === "Domain not found or not claimed";
        
        if (isDomainNotClaimedError) {
          return null; // Domain not claimed
        }
        
        // Re-throw other errors (403, 500, unexpected 404s, etc.)
        throw error;
      }
    },
    enabled: enabled && !!domain,
    retry: false, // Don't retry on 404
  });
}
